module.exports = __webpack_public_path__ + "static/media/4h.775d8a0a.jpg";